const ERROR_MAP: Array<{ pattern: RegExp; message: string }> = [
  { pattern: /row-level security/i, message: "You don't have permission for this action. Try signing out and back in." },
  { pattern: /failed to fetch|network|ERR_NETWORK|ECONNREFUSED/i, message: "Network error — check your internet connection and try again." },
  { pattern: /JWT expired|token.*expired|invalid.*token/i, message: "Your session has expired. Please sign in again." },
  { pattern: /duplicate key|unique.*constraint|already exists/i, message: "This data already exists. Refresh the page and try again." },
  { pattern: /timeout|ETIMEDOUT/i, message: "The request timed out. Please try again." },
  { pattern: /rate limit|too many requests|429/i, message: "Too many requests. Wait a moment and try again." },
  { pattern: /23503|foreign key/i, message: "Related data is missing. Refresh and try again." },
  { pattern: /PGRST/i, message: "Server error. Please try again or contact support." },
];

export function friendlyError(err: unknown): string {
  const raw = err instanceof Error ? err.message : typeof err === "string" ? err : "Unknown error";
  for (const { pattern, message } of ERROR_MAP) {
    if (pattern.test(raw)) return message;
  }
  if (raw.length > 120) return "Something went wrong. Please try again.";
  return raw;
}
